import React, { useState, useMemo, useCallback, useEffect } from "react"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import PhotoAlbum from "react-photo-album"
import Lightbox from "yet-another-react-lightbox"
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails"
import Zoom from "yet-another-react-lightbox/plugins/zoom"
import Share from "yet-another-react-lightbox/plugins/share"
import Counter from "yet-another-react-lightbox/plugins/counter"

const Gallery = ({ thumbnails, images }) => {
  const [index, setIndex] = useState(-1)

  useEffect(() => {
    console.log("thumbnails:", thumbnails)
    console.log("images:", images)
  }, [thumbnails, images])

  const photos = useMemo(
    () =>
      thumbnails?.images?.map(thumbnail => {
        const thumbnailImage = getImage(thumbnail.localFile)
        return {
          src: thumbnailImage?.images?.fallback?.src ?? "",
          width: thumbnailImage?.width ?? 0,
          height: thumbnailImage?.height ?? 0,
        }
      }) ?? [],
    [thumbnails]
  )

  const slides = useMemo(
    () =>
      images?.images?.map(image => {
        const fullImage = getImage(image.localFile)
        return {
          src: fullImage?.images?.fallback?.src ?? "",
          width: fullImage?.width ?? 0,
          height: fullImage?.height ?? 0,
        }
      }) ?? [],
    [images]
  )

  const renderPhoto = useCallback(
    ({ photo, imageProps: { alt, style, ...rest } }) => {
      const thumbnailIndex = photos.findIndex(p => p.src === photo.src)
      const thumbnailImage = getImage(
        thumbnails?.images?.[thumbnailIndex]?.localFile
      )

      if (!thumbnailImage) {
        console.error(
          `Failed to get image for thumbnail at index ${thumbnailIndex}`
        )
        return null
      }

      return (
        <GatsbyImage
          image={thumbnailImage}
          alt={alt}
          style={{ ...style, width: "100%", height: "100%" }}
          {...rest}
        />
      )
    },
    [thumbnails, photos]
  )

  const renderLightboxImage = useCallback(
    ({ slide }) => {
      const slideIndex = slides.findIndex(s => s.src === slide.src)
      const fullImage = getImage(images?.images?.[slideIndex]?.localFile)

      if (!fullImage) {
        console.error(`Failed to get image for slide at index ${slideIndex}`)
        return null
      }

      return (
        <div style={{ position: "relative", width: "100%", height: "100%" }}>
          <GatsbyImage
            image={fullImage}
            alt=""
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
            }}
            objectFit="contain"
          />
        </div>
      )
    },
    [images, slides]
  )

  const handleClick = useCallback(({ index }) => setIndex(index), [])
  const handleClose = useCallback(() => setIndex(-1), [])

  if (!thumbnails?.images?.length || !images?.images?.length) {
    console.error("Missing thumbnails or images data")
    return <div>No images available</div>
  }

  return (
    <>
      <PhotoAlbum
        layout="masonry"
        photos={photos}
        renderPhoto={renderPhoto}
        onClick={handleClick}
        spacing={4}
      />

      <Lightbox
        open={index >= 0}
        index={index}
        close={handleClose}
        slides={slides}
        render={{ slide: renderLightboxImage }}
        plugins={[Thumbnails, Zoom, Counter, Share]}
        zoom={{
          maxZoomPixelRatio: 5,
          zoomInMultiplier: 2,
          doubleTapDelay: 300,
          doubleClickDelay: 300,
          doubleClickMaxStops: 2,
          keyboardMoveDistance: 50,
          wheelZoomDistanceFactor: 100,
          pinchZoomDistanceFactor: 100,
          scrollToZoom: false,
        }}
        thumbnails={{
          width: 120,
          height: 80,
          border: 2,
          borderRadius: 4,
          padding: 4,
          gap: 16,
        }}
        counter={{ container: { style: { top: "unset", bottom: 0 } } }}
      />
    </>
  )
}

export default Gallery
